
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum ShipmentState {
    Upcoming = "Upcoming",InProgress = "In progress",Finished = "Finished",Closed = "Closed",Cancelled = "Cancelled",
}

export enum ShipmentStateDisplay {
    Upcoming = "Upcoming",InProgress = "InProgress",Finished = "Finished",Closed = "Closed",Cancelled = "Cancelled",
}

export const ShipmentStatePairs = Object.keys(ShipmentState)
  .map(key=> ({id: key, name: ShipmentState[key]}));

export function toString(value?: EnumSelect): string {
  return value ? ShipmentState[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case ShipmentStateDisplay.Upcoming:
            return t`Upcoming`;
            
        case ShipmentStateDisplay.InProgress:
            return t`In progress`;
            
        case ShipmentStateDisplay.Finished:
            return t`Finished`;
            
        case ShipmentStateDisplay.Closed:
            return t`Closed`;
            
        case ShipmentStateDisplay.Cancelled:
            return t`Cancelled`;
            
        default:
            return undefined;
    }
}
